// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"820":"dabcf7c3","941":"908eec89","9550":"b16be433"}[chunkId] + ".chunk.css";
};